<template>
  <div class="main-container flex flex-center">
    <div class="main-box">
      <!--头部导航-->
      <div class="box-header flex flex-center">
        <div class="box-header-left flex flex-center">
          <span
            class="header-span"
            :class="{ 'header-span-active': active1 == 1 }"
            @click="changeTab1(1)"
            >{{ $t("m.options.listTab.time") }}</span
          >
          <span
            class="header-span"
            :class="{ 'header-span-active': active1 == 2 }"
            @click="changeTab1(2)"
            >{{ $t("m.options.listTab.name") }}</span
          >
          <span
            class="header-span"
            :class="{ 'header-span-active': active1 == 3 }"
            @click="changeTab1(3)"
            >{{ $t("m.options.listTab.rating") }}</span
          >
        </div>
        <div class="box-header-right">
          <div class="box-header-right">
            <el-button
              type="primary"
              icon="el-icon-search"
              class="active-icon"
              @click="dialogTableVisible3 = true"
            ></el-button>
            <el-button
              type="primary"
              icon="el-icon-plus"
              class="active-icon"
              @click="createComment"
              >{{ $t("m.options.listTab.create") }}</el-button
            >
          </div>
        </div>
      </div>
      <!--内容-->
      <div style="height: calc(100% - 55px);">
        <div class="box-content">
          <div
            @click="checkDevice(item)"
            :class="[
              item.id == selectCommentId
                ? 'box-item box-half box-bc box-active'
                : 'box-item box-half box-bc',
            ]"
            v-for="item in commentList"
            v-bind:key="item.id"
          >
            <div class="box-item-text">
              <div class="box-item-title">
                {{ item.score }}{{ $t("m.chart.table.score") }}
              </div>
              <div>
                <span class="gray-text"
                  >{{ $t("m.cupEvaluate.table.name") }}: </span
                ><span class="white-text">{{ item.name }}</span>
              </div>
              <div>
                <span class="gray-text">{{ $t("m.chart.table.date") }}：</span
                ><span class="white-text">{{
                  $moment(Number(item.updatetime)).format("YYYY-MM-DD")
                }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="table-footer">
          <el-pagination
              background
              align="right"
              layout="prev, pager, next"
              @current-change="commentPageChange"
              :page-size="page.pageSize"
              :total="page.total"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <div class="main-box border-1px-all">
      <comment-detail
        @finish="commentDetailLoadingFinish"
        :chart="showChart"
        :suit-id="selectSuitId"
        :comment-id="selectCommentId"
        :edit="false"
        :isAdd="isAdd"
        :cupUser="cupUser"
      ></comment-detail>
    </div>

    <!--------搜索弹框---------->
    <el-dialog
      :title="$t('m.chart.table.search')"
      :visible.sync="dialogTableVisible3"
      width="500px"
      :show-close="false"
    >
      <div>
        <div class="flex flex-center flex-between" style="margin-bottom:10px;">
          <span class="search-dialog-title">{{
            $t("m.options.listTab.name")
          }}</span>
          <el-input
            :placeholder="$t('m.chart.table.placeholder3')"
            v-model="searchCommentName"
          ></el-input>
        </div>
      </div>
      <div slot="footer" class="flex flex-center">
        <div @click="dialogTableVisible3 = false" class="dialog-footer-btn">
          {{ $t("m.chart.table.cancel") }}
        </div>
        <div type="primary" @click="searchByName" class="dialog-footer-btn">
          {{ $t("m.chart.table.confirm") }}
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import commentDetailComponent from "@/components-online/cupping/commentDetailComponent";
export default {
  name: "equipment-list",
  components: {
    "comment-detail": commentDetailComponent,
  },
  data() {
    return {
      isAdd: false,
      commentDetailDialog: false,
      orderParamKey: "/manage/comment/getListByUserOrderbyName.do",
      orderParamsKeyOptions: [
        {
          value: "/manage/comment/getListByUserOrderbyName.do",
          label: "首字母",
        },
        {
          value: "/manage/comment/getListByUserOrderbyScore.do",
          label: "分数",
        },
      ],
      sortUrl: [
        [
          {
            value: "/manage/comment/getListByUserOrderbyName.do",
            label: "首字母",
          },
          {
            value: "/manage/comment/getListByUserOrderbyScore.do",
            label: "分数",
          },
        ],
        [
          {
            value: "/manage/comment/getListAllOrderbyName.do",
            label: "首字母",
          },
          { value: "/manage/comment/getListAllOrderbyScore.do", label: "分数" },
        ],
      ],
      commentList: [],
      page: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
      },
      url: "/manage/comment/getListByUser.do", //不带参数的搜索url
      searchUrl: "/manage/comment/searchByName.do", //但参数的url,
      params: {
        params: {
          pageSize: 20,
          pageNum: 1,
        },
      },
      searchCommentName: "",
      selectCommentIds: [],
      selectCommentId: 0,
      refreshCommentDetail: false,
      editCommentDetailDialog: false,
      activeUrl: "/manage/comment/getListByUser.do",
      selectSuitId: 0,
      showChart: true,
      loading: undefined,

      active1: 1,

      name: "",
      date: "",
      selectValue: "",
      options: [
        {
          label: "等级一",
          value: "1",
        },
        {
          label: "等级二",
          value: "2",
        },
      ],
      sliderValue: 30,
      num1: 3,
      num2: 0,
      num3: 0,
      dialogTableVisible3: false,
      moveFlag: false,
      cupUser: true,
    };
  },
  mounted() {
    if (localStorage.role != 1) {
      this.cupUser = false;
    }
    this.getCommentList(this.url, this.params);
  },
  methods: {
    hideEditComment() {
      this.editCommentDetailDialog = false;
      this.params.pageNum = 1;
      this.params.pageSize = 20;
      this.$message.success(this.$t("m.alert.deleteSuccess"));
      this.getCommentList(this.url, this.params);
    },
    commentPageChange(val) {
      this.page.pageNum = val;
      this.params.params.pageNum = val;
      this.getCommentList(this.activeUrl, this.params);
    },
    commentPageSizeChange(val) {
      this.page.pageSize = val;
      this.params.params.pageSize = val;
      this.getCommentList(this.activeUrl, this.params);
    },
    commentSelectChange(val) {
      console.info(val);
      this.selectCommentIds = [];
      if (val.length > 0) {
        for (let i in val) {
          this.selectCommentIds.push(val[i].id);
        }
      }
    },
    deleteCommentClick(comment, index) {
      this.$confirm(
        this.$t("m.alert.deleteConfirm"),
        this.$t("m.alert.reminder"),
        {
          confirmButtonText: this.$t("m.alert.confirm"),
          cancelButtonText: this.$t("m.alert.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          let commentIds = new Array();
          commentIds.push(comment.id);
          let params = new URLSearchParams();
          params.append("commentIds", commentIds);
          this.$http
            .post("/manage/comment/deleteComments.do", params)
            .then(
              function(resp) {
                if (resp.data.success) {
                  this.$message.success(this.$t("m.alert.deleteSuccess"));
                  this.commentList.splice(index, 1);
                } else {
                  this.$message.error(
                    "" + resp.data.msg
                  );
                }
              }.bind(this)
            )
            .catch((err) => {
              console.info(err);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("m.alert.canceled"),
          });
        });
    },
    deleteCommentBatchClick() {
      if (this.selectCommentIds.length > 0) {
        this.$confirm(
          this.$t("m.alert.deleteConfirm"),
          this.$t("m.alert.reminder"),
          {
            confirmButtonText: this.$t("m.alert.confirm"),
            cancelButtonText: this.$t("m.alert.cancel"),
            type: "warning",
          }
        ).then(() => {
          let params = new URLSearchParams();
          params.append("commentIds", this.selectCommentIds);
          this.$http
            .post("/manage/comment/deleteComments.do", params)
            .then(
              function(resp) {
                if (resp.data.success) {
                  this.$message.success(this.$t("m.alert.deleteSuccess"));
                  this.getCommentList(this.url, this.params);
                  this.selectCommentIds = [];
                } else {
                  this.$message.error(
                    "" + resp.data.msg
                  );
                }
              }.bind(this)
            )
            .catch((err) => {
              console.info(err);
            });
        });
      } else {
        this.$message.error("请先选择对应的杯测");
      }
    },
    sortBean(sortType) {
      console.info(sortType);
    },
    editCommentDetailClick(comment) {
      // this.$router.push({path:'/comment-detail',query:{commentId:comment.id}})
      this.selectCommentId = comment.id;

      this.editCommentDetailDialog = true;
    },
    commentDetailClick(comment) {
      // this.$router.push({path:'/comment-detail',query:{commentId:comment.id}})
      this.selectCommentId = comment.id;
      this.selectSuitId = comment.suitid;
      this.refreshCommentDetail = false;
      // 在组件移除后，重新渲染组件
      // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
      this.$nextTick(() => {
        this.refreshCommentDetail = true;
      });
      this.commentDetailDialog = true;
    },
    sortCommentList(sortType) {
      let paramsCopy = this.params;
      paramsCopy.params["sort"] = sortType;
      this.activeUrl = this.orderParamKey;
      this.getCommentList(this.orderParamKey, paramsCopy);
    },
    searchByName() {
      if (this.searchCommentName.trim().length > 0) {
        let paramsCopy = this.params;
        paramsCopy.params["keyword"] = this.searchCommentName;
        this.activeUrl = this.searchUrl;
        this.getCommentList(this.searchUrl, paramsCopy);
      } else {
        this.activeUrl = this.url;
        this.getCommentList(this.url, this.params);
      }
      this.dialogTableVisible3 = false;
      this.active1 = 0;
    },
    getCommentList(url, params) {
      //console.info(url)
      this.$http
        .get(this.activeUrl, params)
        .then(
          function(resp) {
            if (resp.data.success) {
              this.commentList = resp.data.data.list;
              this.page.total = resp.data.data.total;
              if (this.page.total > 0) {
                this.selectCommentId = resp.data.data.list[0].id;
                this.selectSuitId = resp.data.data.list[0].suitid;
                this.refreshCommentDetail = false;
                this.isAdd = false;
                // 在组件移除后，重新渲染组件
                // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
                this.$nextTick(() => {
                  this.refreshCommentDetail = true;
                });
              } else {
                console.log("111111111");
                this.isAdd = true;
                this.selectCommentId = 0;
                this.refreshCommentDetail = false;
                // 在组件移除后，重新渲染组件
                // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
                this.$nextTick(() => {
                  this.refreshCommentDetail = true;
                });
              }
            } else {
              this.$message.error(this.$t("m.alert.error"));
            }
          }.bind(this)
        )
        .catch((err) => {
          console.info(err);
        });
    },
    checkDevice(item) {
      this.selectCommentId = item.id;
      this.selectSuitId = item.suitid;
      this.refreshCommentDetail = false;
      this.isAdd = false;
      // 在组件移除后，重新渲染组件
      // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
      this.$nextTick(() => {
        this.refreshCommentDetail = true;
      });
    },
    commentDetailLoadingFinish() {
      //this.loading.close()
    },
    changeTab1(tab) {
      console.info("获取杯测列表");
      var url = "/manage/comment/getListByUser.do";
      var active = 1;
      var sortType = 1;
      if (tab == 1) {
        url = "/manage/comment/getListByUser.do";
        active = 1;
      } else if (tab == 2) {
        url = "/manage/comment/getListByUserOrderbyName.do";
        active = 2;
      } else if (tab == 3) {
        url = "/manage/comment/getListByUserOrderbyScore.do";
        sortType = 2;
        active = 3;
      }
      this.active1 = active;
      let paramsCopy = this.params;
      paramsCopy.params["sort"] = sortType;
      this.$http
        .get(url, paramsCopy)
        .then(
          function(resp) {
            if (resp.data.success) {
              this.commentList = resp.data.data.list;
              this.page.total = resp.data.data.total;

              this.selectCommentId = resp.data.data.list[0].id;
              this.selectSuitId = resp.data.data.list[0].suitid;
              this.refreshCommentDetail = false;
              this.isAdd = false;
              // 在组件移除后，重新渲染组件
              // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
              this.$nextTick(() => {
                this.refreshCommentDetail = true;
              });
            } else {
              this.$message.error(this.$t("m.alert.error"));
            }
          }.bind(this)
        )
        .catch((err) => {
          console.info(err);
        });
    },
    createComment() {
      this.isAdd = true;
      this.selectCommentId = 0;
      this.refreshCommentDetail = false;
      // 在组件移除后，重新渲染组件
      // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
      this.$nextTick(() => {
        this.refreshCommentDetail = true;
      });
    },
    cupPageChange(val) {
      console.info(val);
      this.params.params.pageNum = val;
      this.changeTab1(this.active1);
    },
  },
};
</script>
<style lang="scss" scoped>
.table-footer {
  position: sticky;
  bottom: 0;
  background: #1a1b1c29;
  padding-top: 10px;
}
</style>
